import { IconName } from "@blueprintjs/core";

import TypedRegistry from "core/util/TypedRegistry";
import { Category } from "./entities";


interface ICategoryTypeProps<T> {
	category: Category<T>;
	editing: boolean;
	onChange: (category: Category<T>) => void;
}

export interface ICategoryType<T = any> {
	type: string;
	label: string;
	icon: IconName;
	render: (props: ICategoryTypeProps<T>) => React.ReactNode;
	renderAppearanceForm?: (uiSchema: T, onChange: (uiSchema: T) => void) => React.ReactNode;
}

export const CategoryTypeRegistry = new TypedRegistry<ICategoryType>((o) => o.type);



// WEBPACK FOOTER //
// ./src/panels/kb/category/ICategoryType.ts